// Ikony właściwości miodów: czarne ikony PNG z folderu src/zdjecia/ikony.
// Dopasowanie po słowach kluczowych (RULES – kolejność ma znaczenie, pierwsza
// trafiona wygrywa), na końcu fallback: clean.png.
import Allergy from './zdjecia/ikony/Allergy.png';
import AntiInflammatory from './zdjecia/ikony/Anti inflammatory.png';
import Antioxidant from './zdjecia/ikony/Antioxidant.png';
import BacteriaShield from './zdjecia/ikony/Bacteria shield.png';
import BloodCirculation from './zdjecia/ikony/Blood circulation.png';
import Boost from './zdjecia/ikony/boost.png';
import BrainBulb from './zdjecia/ikony/Brain bulb.png';
import Breathing from './zdjecia/ikony/breathing.png';
import Clean from './zdjecia/ikony/clean.png';
import CoffeeBeans from './zdjecia/ikony/coffee-beans.png';
import Energy from './zdjecia/ikony/energy.png';
import Eye from './zdjecia/ikony/eye.png';
import Fever from './zdjecia/ikony/Fever.png';
import Fire1 from './zdjecia/ikony/fire (1).png';
import Fresh from './zdjecia/ikony/Fresh.png';
import FullBattery from './zdjecia/ikony/full-battery.png';
import Glucose from './zdjecia/ikony/glucose.png';
import HappyFace from './zdjecia/ikony/happy-face.png';
import HeartPulse from './zdjecia/ikony/Heart pulse.png';
import HumanHealth from './zdjecia/ikony/Human health.png';
import HydratedSkin from './zdjecia/ikony/hydrated-skin.png';
import ImmunityShield from './zdjecia/ikony/Immunity shield.png';
import Kidneys from './zdjecia/ikony/kidneys.png';
import Levitation from './zdjecia/ikony/levitation.png';
import Magnesium from './zdjecia/ikony/magnesium.png';
import Moon from './zdjecia/ikony/moon.png';
import Muscle from './zdjecia/ikony/muscle.png';
import Natural from './zdjecia/ikony/natural.png';
import RecycleLeaf from './zdjecia/ikony/Recycle leaf.png';
import Relieved from './zdjecia/ikony/relieved.png';
import SoreThroat from './zdjecia/ikony/sore-throat.png';
import Stomach from './zdjecia/ikony/stomach.png';
import Stomach2 from './zdjecia/ikony/stomach2.png';
import Stress from './zdjecia/ikony/stress.png';
import SugarFree from './zdjecia/ikony/sugar-free.png';
import Sweat from './zdjecia/ikony/sweat.png';
import UrologyWater from './zdjecia/ikony/urology_water.png';
import VitaminC from './zdjecia/ikony/vitamin-c.png';
import VitaminE from './zdjecia/ikony/vitamin-e.png';
import Water from './zdjecia/ikony/water.png';

// Reguły słów kluczowych (katalog.js): kolejność krytyczna – 'witaminy c/e'
// przed resztą witamin, 'minerał/jod/bor' przed 'naturaln', 'magnez' przed
// 'minerał', 'smak' na końcu.
const RULES = [
  { keys: ['oczy'], icon: Eye },
  { keys: ['pamięć', 'koncentracj'], icon: BrainBulb },
  { keys: ['stres'], icon: Stress },
  { keys: ['alerg'], icon: Allergy },
  { keys: ['krąż'], icon: BloodCirculation },
  { keys: ['serce'], icon: HeartPulse },
  { keys: ['oddech'], icon: Breathing },
  { keys: ['przeciwzapaln'], icon: AntiInflammatory },
  { keys: ['przeciwbakteryjn', 'antybakteryjn'], icon: BacteriaShield },
  { keys: ['odpornoś'], icon: ImmunityShield },
  { keys: ['regeneruj'], icon: RecycleLeaf },
  { keys: ['organizm'], icon: HumanHealth },
  { keys: ['przeciwutleniaj', 'antyoksyd'], icon: Antioxidant },
  { keys: ['przeciwgorączk', 'przeziębien'], icon: Fever },
  { keys: ['podrażnien', 'gardł'], icon: SoreThroat },
  { keys: ['napotn'], icon: Sweat },
  { keys: ['zasypian'], icon: Moon },
  { keys: ['trawien'], icon: Stomach },
  { keys: ['żołądk'], icon: Stomach2 },
  { keys: ['nudnoś'], icon: Relieved },
  { keys: ['odświeża'], icon: Fresh },
  { keys: ['witalnoś'], icon: Boost },
  { keys: ['skórę', 'śluzow'], icon: HydratedSkin },
  { keys: ['energi'], icon: Energy },
  { keys: ['zmęczen'], icon: FullBattery },
  { keys: ['glukoz'], icon: Glucose },
  { keys: ['białk'], icon: Muscle },
  { keys: ['witaminy c'], icon: VitaminC },
  { keys: ['witaminy e'], icon: VitaminE },
  { keys: ['magnez'], icon: Magnesium },
  { keys: ['minerał', 'mikroelement', 'jodu', 'boru'], icon: Clean }, // Zamiennik
  { keys: ['kawy', 'kofein'], icon: CoffeeBeans },
  { keys: ['nastrój'], icon: HappyFace },
  { keys: ['rozgrz'], icon: Fire1 },
  { keys: ['cukru'], icon: SugarFree },
  { keys: ['naturaln'], icon: Natural },
  { keys: ['nerki'], icon: Kidneys },
  { keys: ['moczopędn'], icon: Water },
  { keys: ['moczow'], icon: UrologyWater },
  { keys: ['smak'], icon: Levitation }
];

// Zwraca obraz (src) dla tekstu właściwości, np. „Wspiera serce" → Heart pulse.png.
export const propertyIcon = (text) => {
  const needle = text.toLowerCase();
  const rule = RULES.find((r) => r.keys.some((key) => needle.includes(key)));
  return rule ? rule.icon : Clean;
};